export default __webpack_public_path__ + "static/media/img--design-8.99dea4b0.jpg";